// Årsavslutning og skatt (no).
window.PlummeI18n.register('no', {
  // ------------------------------------------------- Arsavslutning / skatt
  'clo.close': 'Lukk',
  'clo.change': 'Endre',
  'clo.save': 'Lagre',
  'clo.cancel': 'Avbryt',
  'clo.showDetails': 'Vis detaljer',
  'clo.sum': 'Sum',
  'clo.addAsset': 'Legg til anleggsmiddel',
  'clo.no': 'Nei',
  'clo.delete': 'Slett',
  'clo.details': 'Detaljer',
  'clo.addedByUser': 'Lagt til av bruker',
  'clo.removeChange': 'Fjern endring',
  'clo.done': 'Ferdig',
  'clo.required': 'Påkrevd',
  'clo.seeDetails': 'se detaljer',
  'clo.searchAccounts': 'Søk i kontoer',
  'clo.noMatches': 'Ingen treff',
  'clo.searchShort': 'Søk …',
  'clo.addValue': 'Legg til verdi',
  'clo.pick': 'Velg',
  'clo.changed': 'Endret',
  'clo.override': 'Overstyr',
  'clo.add': 'Legg til',
  'clo.type': 'Type',
  'clo.amount': 'Beløp',
  'clo.wealthValue': 'Formuesverdi',
  'clo.totalReportableBenefit': 'Samlet opplysningspliktig ytelse',
  'clo.autoCalculated': 'Beregnes automatisk',
  'clo.valueType': 'Verditype',
  'clo.bookValue': 'Regnskapsmessig verdi',
  'clo.taxValue': 'Skattemessig verdi',
  'clo.inventoryTotal': 'Sum verdi av varelager',
  'clo.inventorySpec': 'Spesifikasjon av varelager',
  'clo.equityChange': 'Egenkapitalendring',
  'clo.equityChangeType': 'Egenkapitalendringstype',
  'clo.principleChange': 'Prinsippendring',
  'clo.plBalanceType': 'Resultat- og balanseregnskapstype',
  'clo.cannotChange': 'Kan ikke endres',
  'clo.description': 'Beskrivelse',
  'clo.openingEquity': 'Inngående egenkapital',
  'clo.equityChanges': 'Egenkapitalendringer',
  'clo.profitLossForYear': 'Årets overskudd/underskudd',
  'clo.principleChanges': 'Prinsippendringer',
  'clo.closingEquity': 'Utgående egenkapital',
  'clo.addEquityChange': 'Legg til egenkapitalendring',
  'clo.addPrincipleChange': 'Legg til prinsippendring',
  'clo.principleChangeHelp': 'Velg regnskapskontoen som prinsippendringen gjelder. Beløpene lagres bare i skattemeldingsutkastet.',
  'clo.employerTaxBenefit': 'Samlet arbeidsgiveravgiftspliktig ytelse',
  'clo.accountNumber': 'Kontonummer',
  'clo.accountName': 'Kontonavn',
  'clo.reportableSalaryBenefit': 'Lønnsopplysningspliktig ytelse',
  'clo.employerTaxBenefitShort': 'Arbeidsgiveravgiftspliktig ytelse',
  'clo.detailedPayrollCost': 'Detaljert lønns- og pensjonskostnad',
  'clo.detailedPayrollHelp': 'Legg inn den skattemessige spesifikasjonen per konto. Opplysningene lagres bare i skattemeldingsutkastet.',
  'clo.addDetailedPayroll': 'Legg til detaljert lønns- og pensjonskostnad',
  'clo.noTempDiffsShort': 'Ingen midlertidige forskjeller registrert',
  'clo.changeVerb': 'endre',
  'clo.lastYear': 'I fjor',
  'clo.thisYear': 'I år',
  'clo.movement': 'Endring',
  'clo.bookValueHelp': 'Verdien slik den er ført i regnskapet etter regnskapslovens regler — f.eks. basert på historisk kost minus regnskapsmessige avskrivninger.',
  'clo.taxValueHelp': 'Verdien slik den beregnes etter skattelovens regler — f.eks. basert på saldoavskrivning. Avviker ofte fra regnskapsmessig verdi.',
  'clo.difference': 'Forskjell',
  'clo.differenceHelp': 'Differansen mellom regnskapsmessig og skattemessig verdi. Denne forskjellen reverseres over tid og påvirker skattegrunnlaget. Endringen i årets forskjell legges til eller trekkes fra i beregningen av årets skattegrunnlag.',
  'clo.permanentDiff': 'Permanent forskjell',
  'clo.permanentDiffType': 'Permanent forskjellstype',
  'clo.additionToBusinessIncome': 'Tillegg i næringsinntekt',
  'clo.deductionFromBusinessIncome': 'Fradrag fra næringsinntekt',
  'clo.optionalDescription': 'Valgfri beskrivelse',
  'clo.temporaryDiff': 'Midlertidig forskjell',
  'clo.temporaryDiffType': 'Midlertidig forskjellstype',
  'clo.bookValuePrevYear': 'Regnskapsmessig verdi forrige inntektsår',
  'clo.taxValuePrevYear': 'Skattemessig verdi forrige inntektsår',
  'clo.diffMovement': 'Endring i forskjell',
  'clo.back': 'Tilbake',
  'clo.calculation': 'Beregning',
  'clo.taxBase': 'Skattegrunnlag',
  'clo.lossCarryforward': 'Underskudd til fremføring',
  'clo.deferredTaxOrAsset': 'Utsatt skatt / skattefordel',
  'clo.permanentDiffs': 'Permanente forskjeller',
  'clo.noPermanentDiffs': 'Ingen permanente forskjeller registrert.',
  'clo.temporaryDiffs': 'Midlertidige forskjeller',
  'clo.noTemporaryDiffs': 'Ingen midlertidige forskjeller registrert.',
  'clo.additionalSpecs': 'Tilleggsspesifikasjoner',
  'clo.assetsAndInventory': 'Eiendeler og varelager',
  'clo.sharesAndInvestments': 'Aksjer og investeringer',
  'clo.otherWealth': 'Annen formue',
  'clo.debt': 'Gjeld',
  'clo.objectIdentifier': 'Objektidentifikator',
  'clo.basis': 'Grunnlag',
  'clo.closingValue': 'Utgående verdi',
  'clo.noAssetsRegistered': 'Ingen anleggsmidler eller gevinst-/tapskontoer registrert.',
  'clo.otherCompanyInfo': 'Andre selskapsopplysninger',
  'clo.investments': 'Investeringer',
  'clo.noInvestments': 'Ingen investeringer registrert.',
  'clo.incomeStatement': 'Resultatregnskap',
  'clo.operatingIncome': 'Driftsinntekt',
  'clo.operatingCost': 'Driftskostnad',
  'clo.balanceSheet': 'Balanse',
  'clo.totalAssets': 'Sum eiendeler',
  'clo.totalEquity': 'Sum egenkapital',
  'clo.totalDebt': 'Sum gjeld',
  'clo.totalEquityAndDebt': 'Sum egenkapital og gjeld',
  'clo.manualAdditions': 'Manuelle tillegg i skattemeldingsutkast',
  'clo.additionalItems': 'Tilleggsposter',
  'clo.specifications': 'Spesifikasjoner',
  'clo.taxReturnLead': 'Skattemeldingen for selskapet bygger på regnskapet. Plumme lager et foreløpig utkast til skattegrunnlag, formue og gjeld.',
  'clo.aboutTaxReturn': 'Om skattemeldingen',
  'clo.aboutTaxReturnHelp': 'Plumme bygger skattemeldingen på regnskapet ditt. Du går gjennom hvert steg, kontrollerer tallene og sender inn. Senere hentes og leveres tall direkte mot Skatteetaten og Altinn.',
  'clo.incomeYear': 'Inntektsår',
  'clo.incomeYearHelp': 'Regnskapsåret skattemeldingen gjelder for. Bytt år øverst til høyre i appen hvis du skal jobbe med et annet år.',
  'clo.financialYear': 'Regnskapsåret',
  'clo.calculatedTax': 'Beregnet skatt',
  'clo.calculatedTaxHelp': 'Foreløpig skatt Plumme beregner ut fra skattegrunnlaget (overskudd justert for permanente og midlertidige forskjeller) ganget med skattesatsen. Er resultatet negativt, blir det 0 og underskuddet føres til fremføring.',
  'clo.lossCarryforwardHelp': 'Et skattemessig underskudd i år kan trekkes fra mot overskudd i senere år. Dette beløpet tas vare på og brukes automatisk neste gang du har overskudd.',
  'clo.toNextYear': 'Til neste år',
  'clo.fetchAndCreateDraft': 'Hent opplysninger og opprett utkast',
  'clo.fetchAndCreateDraftHelp': 'I dag bygger Plumme utkastet på tallene du selv har bokført i regnskapet. Henting av forhåndsutfylte tall direkte fra Skatteetaten og Altinn kommer senere — foreløpig opprettes utkastet lokalt. Deretter går du gjennom hvert steg, kontrollerer og sender inn.',
  'clo.checkContactInfo': 'Sjekk kontaktinformasjon',
  'clo.checkContactInfoHelp': 'Kontaktpersonen Skatteetaten bruker hvis de har spørsmål om skattemeldingen din. Hentes fra Plumme-brukeren, men kan endres her.',
  'clo.name': 'Navn',
  'clo.phone': 'Telefonnummer',
  'clo.email': 'E-postadresse',
  'clo.mobile': 'Mobiltelefonnummer',
  'clo.editContactInfo': 'Endre kontaktinformasjon',
  'clo.hasAuditor': 'Har foretaket revisor?',
  'clo.hasAuditorHelp': 'Revisjonspliktige selskaper må ha skattemeldingen godkjent av en registrert revisor før innsending. De fleste små AS er ikke revisjonspliktige så lenge de holder seg under terskelverdiene for omsetning, balansesum og ansatte.',
  'clo.auditorConfirms': 'Skattemeldingen skal bekreftes av revisor',
  'clo.filingDetails': 'Opplysninger om innsendelsen',
  'clo.taxpayer': 'Skattepliktig',
  'clo.filer': 'Innsender',
  'clo.contactInfo': 'Kontaktinformasjon',
  'clo.accountingPeriod': 'Regnskapsperiode',
  'clo.annualAccountsRuleType': 'Regeltype for årsregnskap',
  'clo.annualAccountsRuleTypeHelp': 'Hvilket regelverk årsregnskapet føres etter. Små foretak (under visse terskler for omsetning, balanse og ansatte) kan bruke forenklede regler. IFRS er internasjonale standarder som først og fremst er aktuelle for større/børsnoterte selskaper.',
  'clo.auditorApproval': 'Skal skattemeldingen godkjennes av revisor',
  'clo.taxBaseHelp': 'Beløpet det beregnes skatt av. Tar utgangspunkt i regnskapsmessig resultat, justert for permanente og midlertidige forskjeller og eventuelt fremført underskudd. Også kalt alminnelig inntekt.',
  'clo.taxRate': 'Skattesats',
  'clo.taxRateHelp': 'Prosentsatsen skatten beregnes med. For aksjeselskap er den alminnelige selskapsskatten 22 % av skattegrunnlaget.',
  'clo.taxPayable': 'Betalbar skatt',
  'clo.taxPayableHelp': 'Skatten selskapet faktisk må betale for året: skattegrunnlag × skattesats. Er grunnlaget negativt (underskudd), blir betalbar skatt 0 og underskuddet føres til fremføring.',
  'clo.wealthAndDebt': 'Formue og gjeld',
  'clo.wealth': 'Formue',
  'clo.totalWealthAndDebt': 'Sum formue og gjeld fra næring',
  'clo.netWealthHelp': 'Nettoformue: formue minus gjeld. Danner grunnlag for eiernes formuesskatt. Et AS kan ikke ha negativ nettoformue — da rapporteres 0 kr.',
  'clo.checkTempDiffsLastYear': 'Sjekk midlertidige forskjeller fra i fjor',
  'clo.checkTempDiffsHelp': 'Inngående verdier (01.01) for midlertidige forskjeller og fremførbart underskudd skal stemme med fjorårets skattemelding. Avvik må rettes før du går videre.',
  'clo.tempDiffsAtOpening': 'Midlertidige forskjeller pr 01.01',
  'clo.tempDiffsAtOpeningHelp': 'Summen av midlertidige forskjeller ved årets start — hentet fra fjorårets skattemelding. Skal stemme med utgående verdi i fjor.',
  'clo.lossCarryforwardAtOpening': 'Fremførbart underskudd pr 01.01',
  'clo.lossCarryforwardAtOpeningHelp': 'Ubenyttet skattemessig underskudd fra tidligere år som tas med inn i året og kan trekkes fra mot årets overskudd.',
  'clo.profitBeforeTax': 'Resultat før skatt',
  'clo.profitBeforeTaxHelp': 'Regnskapsmessig overskudd eller underskudd før skattekostnad — alle inntekter minus alle kostnader slik de står i regnskapet.',
  'clo.permanentDiffsExTax': 'Permanente forskjeller ekskl. skatt',
  'clo.permanentDiffsExTaxHelp': 'Inntekter som er skattefrie eller kostnader uten fradragsrett. Disse forsvinner aldri — de påvirker skatten dette året og reverseres ikke senere (f.eks. ikke-fradragsberettiget representasjon).',
  'clo.tempDiffMovement': 'Endring i midlertidig forskjell',
  'clo.tempDiffMovementHelp': 'Årets endring i forskjeller mellom regnskap og skatt som utlignes over tid (f.eks. ulike avskrivninger). Forskyver når skatten betales, men ikke totalt.',
  'clo.priorLossUsedHelp': 'Tidligere års underskudd som benyttes for å redusere årets skattegrunnlag.',
  'clo.taxBaseResultHelp': 'Resultatet av justeringene over — beløpet skatten faktisk beregnes av. Også kalt alminnelig inntekt.',
  'clo.corporateRateHelp': 'Alminnelig selskapsskattesats for aksjeselskap.',
  'clo.taxToPayHelp': 'Skatten som skal betales: skattegrunnlag × 22 %. Blir 0 ved underskudd.',
  'clo.deferredTaxCalc': 'Beregning utsatt skatt / utsatt skattefordel',
  'clo.deferredTaxBasisHelp': 'Samlede forskjeller mellom regnskapsmessige og skattemessige verdier som vil utlignes i fremtiden.',
  'clo.lossCarryforwardShort': 'Fremførbart underskudd',
  'clo.lossCarryforwardShortHelp': 'Ubenyttet underskudd som kan trekkes fra fremtidig overskudd.',
  'clo.unrecognisedDeferredAsset': 'Ikke bokført utsatt skattefordel',
  'clo.deferredTaxBasis': 'Grunnlag for beregning av utsatt skatt',
  'clo.deferredTax': 'Utsatt skatt',
  'clo.deferredTaxHelp': 'Skatt som hører til året, men som først betales senere (utsatt skatt) — eller en fremtidig skattebesparelse (utsatt skattefordel). Vises i balansen, ikke som betalbar skatt nå.',
  'clo.permanentDiffsHelp': 'Inntekter som er skattefrie, eller kostnader som ikke gir fradragsrett — for all tid, ikke bare midlertidig. Eksempel: utbytte under fritaksmetoden, ikke-fradragsberettiget representasjon, eller bøter. Legges til (tillegg) eller trekkes fra (fradrag) regnskapsresultatet for å komme frem til skattegrunnlaget.',
  'clo.addPermanentDiffItem': 'Legg til permanent forskjell-post',
  'clo.addPermanentDiffItemHelp': 'Legg til inntekter som er skattefrie eller kostnader uten fradragsrett som ikke allerede er hentet inn automatisk. Velg type og legg inn beløpet.',
  'clo.addPermanentDiff': 'Legg til permanent forskjell',
  'clo.temporaryDiffsHelp': 'Forskjeller mellom regnskapsmessige og skattemessige verdier som vil utlignes over tid. F.eks. er avskrivningssatser ulike i regnskapsloven og skatteloven, noe som gir ulik kostnad hvert år — men totalkostnaden blir lik. Endring i midlertidig forskjell påvirker når skatten betales, ikke totalskattebelastningen.',
  'clo.addTempDiffItem': 'Legg til midlertidig forskjell-post',
  'clo.addTempDiffItemHelp': 'Midlertidige forskjeller som Plumme ikke har hentet automatisk kan legges til manuelt her. Velg post (konto/eiendelstype) og legg inn regnskapsmessig og skattemessig verdi.',
  'clo.addTempDiff': 'Legg til midlertidig forskjell',
  'clo.lossCarryforwardLongHelp': 'Skattemessig underskudd fra et år kan overføres til fremtidige år og brukes til å redusere skattegrunnlaget da selskapet har overskudd. Det er ingen tidsbegrensning på fremføring av underskudd i Norge — det kan brukes så lenge det finnes overskudd å motregne mot.',
  'clo.priorLossCarried': 'Fremført underskudd fra tidligere år',
  'clo.priorLossCarriedHelp': 'Opphopet skattemessig underskudd fra år før dette året. Beløpet føres automatisk fra fjorårets skattemelding.',
  'clo.debtSettlement': 'Oppnådd underhåndsakkord og gjeldsettergivelse',
  'clo.debtSettlementHelp': 'Hvis kreditor ettergir gjeld under en frivillig akkordordning, kan dette redusere fremførbart underskudd. Tidligere også kalt underhåndsakkord. Påvirker ikke beregningen i Plumme – før det i skattemeldingen hos Skatteetaten.',
  'clo.debtSettlementRest': 'Rest oppnådd underhåndsakkord og gjeldsettergivelse',
  'clo.debtSettlementRestHelp': 'Eventuelt resterende gjeldsettergivelsesbeløp som ennå ikke er brukt til å redusere underskuddet.',
  'clo.lossUsedThisYear': 'Årets anvendelse av fremført underskudd fra tidligere år',
  'clo.lossUsedThisYearHelp': 'Hvor mye av det fremførte underskuddet som brukes til å motregne mot årets overskudd. Må ikke overstige årets skattegrunnlag (før denne posten).',
  'clo.lossCarryforwardInIncome': 'Fremførbart underskudd i inntekt',
  'clo.lossCarryforwardInIncomeHelp': 'Resulterende fremførbart underskudd til neste år: forrige saldo minus årets anvendelse, pluss eventuelt nytt underskudd.',
  'clo.addSpecification': 'Legg til spesifikasjon',
  'clo.overview': 'Oversikt',

  'clo.notCalculatedInPlumme': 'Påvirker ikke beregningen i Plumme – før det i skattemeldingen hos Skatteetaten.',
  'clo.taxAssetsNotCalculated': 'Eiendeler du legger til manuelt her påvirker ikke beregningen i Plumme – før dem i skattemeldingen hos Skatteetaten. Bare driftsmidler fra eiendelsregisteret inngår i skattegrunnlaget.',
  'clo.notCalculatedTitle': 'Beregnet skatt må avklares.',
  'clo.notCalculatedBody': 'Utkastet inneholder opplysninger som ikke inngår i Plummes skatteberegning: {{items}}. Før dem i skattemeldingen hos Skatteetaten, og få skatten kontrollert av en regnskapsfører.',
  'clo.notCalculatedInput.groupContribution': 'konsernbidrag',
  'clo.notCalculatedInput.skattefunn': 'SkatteFUNN',
  'clo.notCalculatedInput.foreignTaxCredit': 'fradrag for skatt betalt i utlandet',
  'clo.notCalculatedInput.foreignSubsidiaryTaxCredit': 'fradrag for skatt på utbytte fra utenlandsk datterselskap',
  'clo.notCalculatedInput.foreignTaxReversal': 'tilbakeført utenlandsk skatt',
  'clo.notCalculatedInput.debtForgiveness': 'underhåndsakkord og gjeldsettergivelse',
  'clo.notCalculatedInput.manualTaxAssets': 'manuelt lagt til eiendeler',
  'clo.taxProvisionStaleTitle': 'Bokført skatt er utdatert.',
  'clo.taxProvisionStaleBody': 'Skattegrunnlaget er endret etter at året ble lukket. Bokført betalbar skatt er {{booked}}, mens utkastet nå gir {{current}}. Gjenåpne året og lukk det på nytt før skattemeldingen eller årsregnskapet leveres.',
  'clo.lossUsedThisYearCalculatedHelp': 'Beregnes automatisk for aksjeselskap: fremført underskudd brukes mot årets positive skattegrunnlag så langt det rekker, og anvendelsen kan ikke utsettes.',
  'clo.aiTaxAssetSaved': 'Eiendelen er lagt til i eiendelsspesifikasjonen i utkastet. Den påvirker ikke skatteberegningen i Plumme – før den i skattemeldingen hos Skatteetaten.',

  // ---- Fase 1: SkattemeldingPage toasts og inline tekst ----
  'clo.contactInfoSaved': 'Kontaktinformasjon lagret',
  'clo.taxDraftSaveFailed': 'Kunne ikke lagre skattemeldingsutkastet.',
  'clo.taxBasisSaveFailed': 'Kunne ikke lagre skattegrunnlaget.',
  'clo.itemAdded': '{{title}} lagt til',
  'clo.permanentDiffSaved': 'Permanent forskjell lagret',
  'clo.entryDeleted': 'Posten ble slettet',
  'clo.temporaryDiffSaved': 'Midlertidig forskjell lagret',
  'clo.specificationRemoved': 'Spesifikasjon fjernet',
  'clo.taxAssetSaveFailed': 'Kunne ikke lagre eiendelsspesifikasjonen.',
  'clo.assetSaved': '{{title}} lagret',
  'clo.assetFallback': 'Eiendel',
  'clo.objectDeleted': 'Objektet ble slettet',
  'clo.taxOtherSaveFailed': 'Kunne ikke lagre andre opplysninger.',
  'clo.ownerBenefitsSaved': 'Ytelser lagret',
  'clo.companyInfoSaved': 'Selskapsopplysninger lagret',
  'clo.soleTraderChecksSaved': 'ENK-kontrollene er lagret',
  'clo.taxSettlementSaved': 'Skatteoppgjøret er lagret',
  'clo.investmentSaved': '{{title}} lagret',
  'clo.investmentFallback': 'Investering',
  'clo.investmentDeleted': 'Investeringen ble slettet',
  'clo.incomeBalanceSaveFailed': 'Kunne ikke lagre resultatregnskap og balanse.',
  'clo.enterAccountBeforeSaving': 'Legg inn kontonummer og kontonavn før du lagrer posten.',
  'clo.entrySaved': 'Post lagret',
  'clo.entryDeletedShort': 'Post slettet',
  'clo.specificationSaved': 'Spesifikasjon lagret',
  'clo.specificationDeleted': 'Spesifikasjon slettet',
  'clo.detailedPayrollSpecDeleted': 'Detaljert lønnsspesifikasjon slettet',
  'clo.equityChangeSaved': 'Egenkapitalendring lagret',
  'clo.equityChangeDeleted': 'Egenkapitalendring slettet',
  'clo.principleChangeSaved': 'Prinsippendring lagret',
  'clo.principleChangeDeleted': 'Prinsippendring slettet',
  'clo.draftMissingControls': 'Utkastet mangler {{count}} obligatoriske kontroller. Se varslet øverst og fyll ut feltene før du går videre.',

  'clo.dividendPaidInYear': 'Utbytte som ble vedtatt og utbetalt i løpet av {{year}}',
  'clo.companyToOwnerBenefit': 'Har selskapet gitt lån, sikkerhetsstillelse, salg eller utleie til eier eller nærstående?',
  'clo.ownerToCompanyBenefit': 'Har eier eller nærstående gitt lån, sikkerhetsstillelse, salg eller utleie til selskapet?',
  'clo.loansToOwnerAmount': 'Utestående lån eller ytelser fra selskapet til eier',
  'clo.loansFromOwnerAmount': 'Utestående lån fra eier til selskapet',
  'clo.securityAmount': 'Sikkerhetsstillelser for eier eller nærstående',
  'clo.noteField': 'Notat',
  'clo.industryRegime': 'Næring og særregime',
  'clo.industryRegimeOrdinary': 'Ordinær virksomhet',
  'clo.industryRegimeAgricultureForestry': 'Landbruk eller skogbruk – krever faglig behandling',
  'clo.industryRegimeRegulatedFinance': 'Regulert finansvirksomhet – krever faglig behandling',
  'clo.industryRegimeOtherSpecial': 'Annet særregime – krever faglig behandling',
  'clo.financeTaxApplicability': 'Omfattes selskapet av finansskatt',
  'clo.financeTaxNotApplicable': 'Nei',
  'clo.financeTaxApplicable': 'Ja – krever faglig behandling',
  'clo.financeTaxUnknown': 'Ikke avklart',
  'clo.ownsProperty': 'Eide selskapet fast eiendom ved årsslutt',
  'clo.propertyTaxValue': 'Samlet skattemessig verdi av fast eiendom',
  'clo.propertyDetails': 'Eiendom – adresse, type og verdsettelsesgrunnlag',
  'clo.groupReceivablesAmount': 'Fordringer på konsernselskap',
  'clo.groupDebtAmount': 'Gjeld til konsernselskap',
  'clo.groupDetails': 'Konsernposter og motparter',
  'clo.businessIncomeReviewed': 'Næringsinntekten er kontrollert mot regnskapet',
  'clo.otherPersonalIncomeReviewed': 'Annen inntekt og fradrag i den personlige skattemeldingen er kontrollert',
  'clo.personalReturnReviewed': 'Den personlige skattemeldingen skal kontrolleres sammen med næringsspesifikasjonen',
  'clo.duplicateIncomeChecked': 'Samme inntekt eller fradrag er ikke tatt med både privat og i næringen',
  'clo.spouseAllocationStatus': 'Fordeling med ektefelle',
  'clo.spouseAllocationNotApplicable': 'Ikke aktuelt',
  'clo.spouseAllocationReviewed': 'Fordeling er vurdert og dokumentert',
  'clo.spouseAllocationRequiresReview': 'Må avklares med regnskapsfører',
  'clo.spouseShareAmount': 'Beløp fordelt til ektefelle',
  'clo.spouseAllocationBasis': 'Grunnlag for fordelingen',
  'clo.advanceTaxPaid': 'Ordinær forskuddsskatt innbetalt',
  'clo.additionalAdvanceTax': 'Tilleggsforskudd innbetalt',
  'clo.taxSettlementStatus': 'Status for skatteoppgjøret',
  'clo.taxSettlementPending': 'Ikke mottatt',
  'clo.taxSettlementReceived': 'Mottatt – ikke ferdig bokført',
  'clo.taxSettlementSettled': 'Kontrollert og bokført',
  'clo.finalAssessedTax': 'Fastsatt skatt i skatteoppgjøret',
  'clo.interestIncome': 'Renteinntekt i oppgjøret',
  'clo.interestExpense': 'Rentekostnad i oppgjøret',
  'clo.settlementDate': 'Dato for skatteoppgjøret',
  'clo.settlementNotesOrRef': 'Notat eller dokumentreferanse',

  'clo.noBalanceOnRelevantAccounts': 'Ingen saldo på relevante kontoer.',
  'clo.submissionAndCompany': 'Innsending og foretak',
  'clo.statusReady': 'Klar',
  'clo.statusMissingInfo': 'Mangler info',
  'clo.statusControl': 'Kontroller',
  'clo.statusNoItems': 'Ingen poster',
  'clo.statusDiscrepancy': 'Avvik',
  'clo.objectsCount': '{{count}} objekter',
  'clo.investmentsCount': '{{count}} investeringer',
  'clo.company': 'Foretak',
  'clo.orgNumber': 'Organisasjonsnummer',
  'clo.taxAssetsCard': 'Eiendeler',
  'clo.otherInfoCard': 'Andre opplysninger',
  'clo.incomeBalanceCard': 'Resultatregnskap og balanse',
  'clo.balanceDeviation': 'Balanseavvik',
  'clo.dividend': 'Utbytte',
  'clo.companyToOwnerShort': 'Selskap til eier',
  'clo.ownerToCompanyShort': 'Eier til selskap',
  'clo.investmentsShort': 'Investeringer',
  'clo.operatingIncomeShort': 'Driftsinntekt',
  'clo.annualResultShort': 'Årsresultat',
  'clo.totalAssetsShort': 'Sum eiendeler',
  'clo.added': 'Lagt til',
  'clo.noSharesOrInvestmentsInTrialBalance': 'Ingen aksje- eller investeringsposter funnet i saldobalansen.',
  'clo.debtRelatedTo': 'Gjeld relatert til',
  'clo.valueColumn': 'Verdi',
  'clo.noDebtItemsInTrialBalance': 'Ingen gjeldsposter funnet i saldobalansen.',
  'clo.prepareTaxBeforeClosing': 'Forbered skatt før året lukkes',
  'clo.prepareTaxBeforeClosingBody': 'Gå gjennom skattegrunnlaget nå. Plumme bruker det godkjente grunnlaget til å postere betalbar skatt når årsavslutningen lukkes. Selve innsendingen er sperret frem til etter lukking.',
  'clo.taxReturnTitle': 'Skattemelding {{year}}',
  'clo.taxReturnIntro': 'Skattemeldingen består av opplysninger fra regnskapet. Senere henter vi tall direkte fra Skatteetaten og Altinn — foreløpig oppretter vi et lokalt utkast med tallene du allerede har bokført.',
  'clo.netBusinessIncome': 'Netto næringsinntekt',
  'clo.mustBeClarified': 'Må avklares',
  'clo.includedInPersonalTaxReturn': 'Inngår i innehaverens personlige skattemelding',
  'clo.mustBePaid': 'Må betales',
  'clo.noCalculatedTaxInDraft': 'Ingen beregnet skatt i utkastet',
  'clo.noRateApplied': 'Ingen sats er brukt',
  'clo.taxCalcRequiresReview': 'Skatteberegning krever faglig avklaring',
  'clo.taxCalcRequiresReviewBody': 'Regnskapstallene kan gjennomgås, men betalbar skatt beregnes ikke før næring, finansskatt og øvrig skatteregime er avklart.',
  'clo.taxReturnNotReadyYet': 'Skattemeldingen er ikke klar ennå.',
  'clo.mandatoryChecksMissing': '{{count}} obligatoriske kontroller mangler. Gå særlig gjennom skattegrunnlag og andre opplysninger.',
  'clo.taxReturnInternallyReviewed': 'Utkastet er internt gjennomgått. Det er ikke validert av Skatteetaten.',
  'clo.draftForCompany': 'Utkast for {{company}}. Gå gjennom hvert steg og bekreft tallene.',
  'clo.theBusinessFallback': 'foretaket',
  'clo.reviewDone': 'Ferdig med gjennomgang',
  'clo.continueLabel': 'Gå videre',
  'clo.taxCalculatedForYear': 'Beregnet skatt for regnskapsåret {{year}}',
  'clo.notCalculated': 'Ikke beregnet',
  'clo.noAdditionsRegistered': 'Ingen tillegg registrert',
  'clo.noDeductionsRegistered': 'Ingen fradrag registrert',
  'clo.calculatedFromAccountCannotEdit': 'Beregnes fra konto {{code}} og kan ikke redigeres her.',
  'clo.calculatedFromAssetRegisterCannotEdit': 'Beregnes fra eiendelsregisteret og kan ikke redigeres her.',
  'clo.missingPriorTaxYear': 'Vi mangler et tidligere skatteår å kontrollere mot. Åpne beløpet over og lagre 0 dersom det ikke finnes fremførbart underskudd.',
  'clo.sumWealthAndDebtAtYearEnd': 'Sum formue og gjeld pr 31.12.{{year}}',
  'clo.limitedCompanyNoNegativeWealth': 'Et aksjeselskap kan ikke ha negativ nettoformue. Derfor vil det rapporteres inn 0 kr i formue for dette selskapet selv om "Sum formue og gjeld" er negativ.',
  'clo.noFixedAssetsRegisteredForYear': 'Ingen anleggsmidler eller gevinst-/tapskontoer registrert for {{year}}.',
  'clo.personalTaxReturnAndBusinessIncome': 'Personlig skattemelding og næringsinntekt',
  'clo.personalTaxReturnAndBusinessIncomeBody': 'Et ENK er ikke et eget skattesubjekt. Kontroller næringsinntekten sammen med øvrige personlige inntekter, fradrag og formue, og unngå at samme beløp rapporteres både privat og i næringen.',
  'clo.businessIncomeFromDraft': 'Næringsinntekt fra utkastet',
  'clo.personalTaxReturnChecked': 'Personlig skattemelding kontrollert',
  'clo.spouseAllocationDetailStatus': 'Fordeling med ektefelle',
  'clo.spouseAllocationReviewedShort': 'Vurdert',
  'clo.duplicateIncomeCheckedLabel': 'Dobbeltføring kontrollert',
  'clo.fillInChecks': 'Fyll ut kontrollene',
  'clo.enkPersonalTaxReturnTitle': 'ENK – personlig skattemelding og næringsinntekt',
  'clo.ownerBenefitsBetweenCompanyAndOwnerTitle': 'Ytelser mellom selskapet og personlig eier',
  'clo.otherCompanyInfoTitle': 'Andre opplysninger om selskapet',
  'clo.advanceTaxAndSettlementTitle': 'Forskuddsskatt og skatteoppgjør',
  'clo.note': 'Notat',
  'clo.advanceTaxAndSettlement': 'Forskuddsskatt og skatteoppgjør',
  'clo.advanceTaxAndSettlementBody': 'Registrer innbetalt forskudd når skattemeldingen klargjøres. Når skatteoppgjøret kommer, kontrolleres fastsatt skatt, renter og eventuell restskatt eller skatt til gode før bokføring.',
  'clo.advancePlusAdditionalPaid': 'Innbetalt forskudd og tilleggsforskudd',
  'clo.estimatedDifferenceVsCalculatedTax': 'Estimert differanse mot beregnet skatt',
  'clo.settlementStatusLabel': 'Status',
  'clo.settlementReceivedShort': 'Mottatt',
  'clo.settlementNotReceivedShort': 'Ikke mottatt',
  'clo.updateSettlement': 'Oppdater oppgjøret',
  'clo.fillSharesInfoBody': 'Rapporter aksjer, fond, obligasjoner, virtuell valuta og andre finansielle instrumenter selskapet eier. Poster fra saldobalansen vises automatisk som forslag.',
  'clo.noSharesOrInvestmentsFound': 'Ingen aksjer eller investeringer funnet i saldobalansen. Legg til manuelle opplysninger hvis selskapet eier slike poster.',
  'clo.sumSalesIncome': 'Sum salgsinntekt',
  'clo.sumOtherOperatingIncome': 'Sum annen driftsinntekt',
  'clo.sumGoodsCost': 'Sum varekostnad',
  'clo.sumPayrollCost': 'Sum lønnskostnad',
  'clo.sumDepreciation': 'Sum avskrivning',
  'clo.sumOtherOperatingCost': 'Sum annen driftskostnad',
  'clo.sumFinanceIncome': 'Sum finansinntekt',
  'clo.sumFinanceCost': 'Sum finanskostnad',
  'clo.balanceDiscrepancyWithAmount': 'Balanseavvik: {{amount}}. Kontroller saldobalansen før innsending.',
  'clo.inventoryValueTitle': 'Verdi av varelager',
  'clo.receivableTaxValueTitle': 'Skattemessig verdi på fordring',
  'clo.payrollPensionSpecTitle': 'Spesifikasjon av lønns- og pensjonskostnad',
  'clo.incomeKind': 'Inntekt',
  'clo.costKind': 'Kostnad',
  'clo.balanceKind': 'Balanse',
  'clo.balanceDiscrepancyBody': 'Eiendeler og egenkapital/gjeld avviker med {{amount}}. Rett avviket i bokføringen før skattemeldingen kontrolleres for innsending.',
  'clo.detailsFallback': 'Detaljer',
  'clo.reviewStepsIntro': 'Gå gjennom stegene til venstre. Når alt er bekreftet, kan utkastet kontrolleres for innsending.',
  'clo.internalRulesOnly': 'Utkastet er bare kontrollert mot Plummes interne regler. Offisiell validering og innsending hos Skatteetaten er ikke koblet.',
  'clo.processingStepPlaceholder': 'Vi viser dette som et behandlingssteg nå. Når ekte integrasjon kommer, hentes status fra Skatteetaten.',
  'clo.netWealthLabel': 'Netto formue',
  'clo.reportedWealth': 'Rapportert formue',
  'clo.savingsDepreciated': 'Saldoavskrevet',
  'clo.linearDepreciated': 'Lineært avskrevet',
  'clo.notDepreciable': 'Ikke avskrivbart',
  'clo.gainLossAccount': 'Gevinst-/tapskonto',
  'clo.yearClosingRequiredBeforeFiling': 'Årsavslutning for {{yearKey}} må fullføres før skattemeldingen kan sendes.',
  'clo.autoInventoryFromIncomeBalanceSpec': 'Varebeholdning fra resultat- og balansespesifikasjonen',
  'clo.autoReceivablesTaxWriteDown': 'Skattemessig nedskrivning på kundefordringer',
  'clo.autoNondeductibleCosts': 'Ikke fradragsberettigede kostnader',
  'clo.autoInterestIncomeOnRepaidTax': 'Renteinntekt på tilbakebetalt skatt bokført på 8040',
  'clo.foreignOwnershipShort': 'Utenlandsk eierskap / grensekryssende omorganisering',
  'clo.subsidiaryInGroupShort': 'Datterselskap i konsern',
  'clo.taxFreeTransferShort': 'Skattefri overføring av eiendeler/forpliktelser',
  'clo.noIncomeAccounts': 'Ingen inntektskontoer.',
  'clo.noCostAccounts': 'Ingen kostnadskontoer.',
  'clo.contactInfoIntro': 'Vi har hentet kontaktinformasjonen fra Plumme-brukeren din. Sjekk at alt stemmer, og legg til det som mangler. Det er denne personen Skatteetaten kontakter hvis de har spørsmål.',
  'clo.hasAuditorIntro': 'Plumme har svart på dette for deg, basert på om foretaket er registrert med revisor i Brønnøysundregistrene. Du kan endre hvis det ikke stemmer.',
  'clo.checkTempDiffsLastYearIntro': 'Plumme har sammenlignet de inngående verdiene mot fjorårets skattemelding. Sjekk at åpningsbalansen stemmer før du går videre.',
  'clo.permanentDiffsIntro': 'Permanente forskjeller vil si inntekter som er skattefrie, eller kostnader som man ikke får skattefradrag for. Utbytte fra selskaper eller salg av aksjer kan være permanente forskjeller hvis de er innenfor fritaksmetoden.',
  'clo.temporaryDiffsIntro1': 'Midlertidige forskjeller vil si at det er forskjell på behandlingen i regnskapet og i skattemeldingen. Det kan for eksempel stamme fra ulike avskrivninger på eiendeler i skatteloven og regnskapsloven, eller at det er avsatt til tap på kundefordringer eller ukurans på varelager.',
  'clo.temporaryDiffsIntro2': 'Midlertidige forskjeller vil si at man betaler skatten i et senere år. En endring i midlertidig forskjell vil påvirke hvor mye skatt selskapet skal betale i år.',
  'clo.lossCarryforwardIntro': 'Fremførbart underskudd er en skatteordning som gjør at hvis bedriften din går med underskudd et år, så får du trekke fra dette underskuddet i framtidige år – når selskapet ditt går med overskudd. Det er altså en type skattefradrag.',
  'clo.ownerTransactionsIntro': 'Oppgi om det har vært utbytte, lån, sikkerhetsstillelse, salg, utleie eller andre ytelser mellom selskapet og personlig eier eller nærstående.',

  // ------------------------------------------- Phase 2: tax-return module-level catalogs
  'clo.permTillegg.0610': 'Ikke fradragsberettigede kostnader (representasjon, kontingenter, gaver, andre)',
  'clo.permTillegg.0620': 'Positiv skattekostnad',
  'clo.permTillegg.0621': 'Rentekostnad på fastsatt skatt',
  'clo.permTillegg.0630': 'Underskuddsandel fra investering i datterselskap, tilknyttet selskap og felleskontrollert virksomhet',
  'clo.permTillegg.0631': 'Tilbakeføring av verdireduksjon av finansielle instrumenter vurdert til virkelig verdi',
  'clo.permTillegg.0632': 'Regnskapsmessig nedskrivning på aksjer og andre finansielle instrumenter i år',
  'clo.permTillegg.0633': 'Regnskapsmessig tap ved realisasjon av aksjer og andre finansielle instrumenter',
  'clo.permTillegg.0635': 'Regnskapsmessig underskudd på andel i norske selskap med deltakerfastsetting',
  'clo.permTillegg.0636': 'Regnskapsmessig underskudd på andel i utenlandske selskap med deltakerfastsetting',
  'clo.permTillegg.0637': 'Regnskapsmessig tap ved realisasjon av andel i norske selskap med deltakerfastsetting',
  'clo.permTillegg.0638': 'Regnskapsmessig tap ved realisasjon av andel i utenlandske selskap med deltakerfastsetting',
  'clo.permTillegg.0645': 'Tilbakeførte gjeldsrenter etter sktl §§ 2-39 (2) og 6-91',
  'clo.permTillegg.0650': 'Skattepliktig gevinst ved realisasjon av aksjer og andre finansielle instrumenter',
  'clo.permTillegg.0652': 'Skattepliktig utbytte på aksjer mv. inklusiv tillegg etter skatteloven § 16-30 (5)',
  'clo.permTillegg.0653': '3 prosent av netto skattefrie inntekter etter fritaksmetoden og 3 prosent av utdeling fra selskap med deltakerfastsetting',
  'clo.permTillegg.0654': '1 prosent av skattepliktig del av mottatt utbytte i verdipapirfond',
  'clo.permTillegg.0655': 'Andel av skattepliktig overskudd i norske selskap med deltakerfastsetting',
  'clo.permTillegg.0656': 'Andel av skattepliktig overskudd i utenlandske selskap med deltakerfastsetting',
  'clo.permTillegg.0657': 'Skattepliktig gevinst ved realisasjon av andel i norske selskap med deltakerfastsetting',
  'clo.permTillegg.0658': 'Skattepliktig gevinst ved realisasjon av andel i utenlandske selskap med deltakerfastsetting',
  'clo.permTillegg.0670': 'Tillegg for rentekostnader det ikke kreves fradrag for',
  'clo.permTillegg.0671': 'Korreksjon for foreslått utbytte fra datterselskap/tilknyttet selskap ved bruk av egenkapitalmetoden',
  'clo.permTillegg.0675': 'Skattepliktig gevinst på uttak fra norsk beskatningsområde',
  'clo.permTillegg.0689': 'Ikke fradragsberettigede kostnader og tap knyttet til utvinning av petroleum i utlandet',
  'clo.permTillegg.0690': 'Andre inntektstillegg',
  'clo.permTillegg.0691': 'Inntektstillegg for omregningsdifferanse fra regnskapsvaluta til norske kroner',
  'clo.permFradrag.0815': 'Tilbakeføring av inntektsført utbytte',
  'clo.permFradrag.0816': 'Resultatført konsernbidrag',
  'clo.permFradrag.0820': 'Negativ skattekostnad',
  'clo.permFradrag.0821': 'Renteinntekt på tilbakebetalt skatt',
  'clo.permFradrag.0830': 'Overskuddsandel fra investering i datterselskap, tilknyttet selskap og felleskontrollert virksomhet',
  'clo.permFradrag.0831': 'Tilbakeføring av verdiøkning av finansielle instrumenter vurdert til virkelig verdi',
  'clo.permFradrag.0832': 'Reversering av tidligere års nedskrivning på aksjer og andre finansielle instrumenter inntektsført i år',
  'clo.permFradrag.0833': 'Regnskapsmessig gevinst ved realisasjon av aksjer og andre finansielle instrumenter',
  'clo.permFradrag.0835': 'Regnskapsmessig overskudd på andel i norske selskap med deltakerfastsetting',
  'clo.permFradrag.0836': 'Regnskapsmessig overskudd på andel i utenlandske selskap med deltakerfastsetting',
  'clo.permFradrag.0837': 'Regnskapsmessig gevinst ved realisasjon av andel i norske selskap med deltakerfastsetting',
  'clo.permFradrag.0838': 'Regnskapsmessig gevinst ved realisasjon av andel i utenlandske selskap med deltakerfastsetting',
  'clo.permFradrag.0850': 'Fradragsberettiget tap ved realisasjon av aksjer og andre finansielle instrumenter',
  'clo.permFradrag.0855': 'Andel av fradragsberettiget underskudd i norske selskap med deltakerfastsetting',
  'clo.permFradrag.0856': 'Andel av fradragsberettiget underskudd i utenlandske selskap med deltakerfastsetting',
  'clo.permFradrag.0857': 'Fradragsberettiget tap ved realisasjon av andel i norske selskap med deltakerfastsetting',
  'clo.permFradrag.0858': 'Fradragsberettiget tap ved realisasjon av andel i utenlandske selskap med deltakerfastsetting',
  'clo.permFradrag.0875': 'Fradragsberettiget tap på uttak fra norsk beskatningsområde',
  'clo.permFradrag.0877': 'Emisjons- og stiftelseskostnader',
  'clo.permFradrag.0879': 'Skattemessig tilbakeføring av FOU-fradrag',
  'clo.permFradrag.0889': 'Skattefri inntekt knyttet til utvinning av petroleum i utlandet',
  'clo.permFradrag.0890': 'Andre inntektsfradrag',
  'clo.permFradrag.0891': 'Inntektsfradrag for omregningsdifferanse fra regnskapsvaluta til norske kroner',
  'clo.midlPost.101': 'Driftsmidler (materielle og immaterielle) og goodwill',
  'clo.midlPost.102': 'Byggelånsrenter',
  'clo.midlPost.110': 'Langsiktige fordringer i utenlandsk valuta',
  'clo.midlPost.111': 'Langsiktig gjeld i utenlandsk valuta',
  'clo.midlPost.120': 'Tilvirkningskontrakt som ikke er fullført ved årsslutt',
  'clo.midlPost.130': 'Varebeholdning',
  'clo.midlPost.135': 'Biologiske eiendeler',
  'clo.midlPost.137': 'Fordring etter fordringsmodellen',
  'clo.midlPost.138': 'Gjeld etter fordringsmodellen',
  'clo.midlPost.140': 'Kundefordringer',
  'clo.midlPost.141': 'Andre fordringer (også langsiktige)',
  'clo.midlPost.146': 'Regnskapsmessig verdi av leasingobjekt i balansen',
  'clo.midlPost.147': 'Regnskapsmessig verdi av leasinggjeld i balansen',
  'clo.midlPost.150': 'Positiv saldo på gevinst- og tapskonto',
  'clo.midlPost.151': 'Negativ saldo på gevinst- og tapskonto',
  'clo.midlPost.152': 'Betingete skattefrie gevinster',
  'clo.midlPost.153': 'Regnskapsmessig uopptjent inntekt',
  'clo.midlPost.154': 'Regnskapsmessige avsetninger for forpliktelser',
  'clo.midlPost.170': 'Regnskapsmessig avsetning til tap på kontrakter',
  'clo.midlPost.172': 'Netto pensjonsforpliktelser som er ført i balansen',
  'clo.midlPost.173': 'Netto pensjonsmidler',
  'clo.midlPost.174': 'Skattemessig avsetning til pensjonspremie mv.',
  'clo.midlPost.180': 'Overtatte forpliktelser ved kjøp av virksomhet',
  'clo.midlPost.182': 'Positiv saldo på tømmerkonto',
  'clo.midlPost.183': 'Negativ saldo på tømmerkonto',
  'clo.midlPost.184': 'Positiv saldo på jordbrukskonto',
  'clo.midlPost.185': 'Negativ saldo på jordbrukskonto',
  'clo.midlPost.191': 'Tillegg for differanse mellom balanseført og virkelig verdi på fusjons-/fisjonstidspunktet ved skattemessig kontinuitet',
  'clo.midlPost.192': 'Fradrag for differanse mellom balanseført og virkelig verdi på fusjons-/fisjonstidspunktet ved skattemessig kontinuitet',
  'clo.midlPost.193': 'Tillegg for differanse mellom skattemessige verdier og balanseført/virkelig verdi ved omdannelse til aksjeselskap med skattemessig kontinuitet',
  'clo.midlPost.194': 'Fradrag for differanse mellom skattemessige verdier og balanseført/virkelig verdi ved omdannelse til aksjeselskap med skattemessig kontinuitet',
  'clo.midlPost.195': 'Fradrag for skattefri gevinst ved overdragelse av eiendel til selskap i samme konsern etter forskrift om skattefrie overføringer',
  'clo.midlPost.196': 'Tillegg for differanse mellom skattemessig inngangsverdi og vederlag på overføringstidspunktet på eiendel overført fra selskap i samme konsern etter forskrift om skattefri overføring',
  'clo.midlPost.198': 'Annen positiv midlertidig forskjell',
  'clo.midlPost.199': 'Annen negativ midlertidig forskjell',
  'clo.extraSpec.konsernbidrag': 'Konsernbidrag',
  'clo.extraSpec.skattefunn': 'Forskning og utvikling (skattefunn)',
  'clo.extraSpec.skattUtlandet': 'Fradrag for skatt betalt i utlandet',
  'clo.extraSpec.skattUtbytteDatter': 'Fradrag for skattelegging av utbytte mv. fra utenlandsk datterselskap',
  'clo.extraSpec.tilbakefortSkatt': 'Tilbakeført utenlandsk skatt senere år',
  'clo.extraSpec.offentligStotte': 'Mottak av skatte- og avgiftsordning omfattet av offentlig støtte',
  'clo.assetGroup.A': 'Kontormaskiner mv.',
  'clo.assetGroup.B': 'Ervervet forretningsverdi',
  'clo.assetGroup.C': 'Vogntog, lastebiler, busser, varebiler mv.',
  'clo.assetGroup.D': 'Personbiler, maskiner og inventar mv.',
  'clo.assetGroup.E': 'Skip, fartøyer, rigger mv.',
  'clo.assetGroup.F': 'Fly, helikopter',
  'clo.assetGroup.G': 'Kraftanlegg og elektroteknisk utrustning',
  'clo.assetGroup.H': 'Bygg og anlegg, hoteller mv.',
  'clo.assetGroup.I': 'Forretningsbygg',
  'clo.assetGroup.J': 'Fast teknisk installasjon i bygninger',
  'clo.assetSchema.saldo.title': 'Saldoavskrevet anleggsmiddel',
  'clo.assetSchema.saldo.lead': 'De fleste anleggsmidler avskrives skattemessig etter saldometoden med fast prosentsats per saldogruppe.',
  'clo.assetSchema.saldo.rows.objectId': 'Objektidentifikator',
  'clo.assetSchema.saldo.rows.grp': 'Saldogruppe',
  'clo.assetSchema.saldo.rows.beskrivelse': 'Objektbeskrivelse',
  'clo.assetSchema.saldo.rows.fysisk': 'Er det fysisk anleggsmiddel i utgående verdi',
  'clo.assetSchema.saldo.rows.inngaende': 'Inngående verdi',
  'clo.assetSchema.saldo.rows.nedskrevet': 'Nedskrevet verdi av utskilt anleggsmiddel',
  'clo.assetSchema.saldo.rows.nyanskaffelse': 'Nyanskaffelse',
  'clo.assetSchema.saldo.rows.pakostning': 'Påkostning',
  'clo.assetSchema.saldo.rows.nedskrivningSkattefri': 'Nedskrivning på nyanskaffelser med betinget skattefri salgsgevinst',
  'clo.assetSchema.saldo.rows.offentlig': 'Offentlig tilskudd',
  'clo.assetSchema.saldo.rows.justeringMva': 'Justering av inngående mva',
  'clo.assetSchema.saldo.rows.vederlag': 'Vederlag ved realisasjon og uttak',
  'clo.assetSchema.saldo.rows.vederlagInnt': 'Vederlag ved realisasjon og uttak inntektsført i år',
  'clo.assetSchema.saldo.rows.grunnlag': 'Grunnlag for avskrivning og inntektsføring',
  'clo.assetSchema.saldo.rows.gevinstOverf': 'Gevinst overført til gevinst- og tapskonto',
  'clo.assetSchema.saldo.rows.tapOverf': 'Tap overført til gevinst- og tapskonto',
  'clo.assetSchema.saldo.rows.sats': 'Avskrivningssats',
  'clo.assetSchema.saldo.rows.avskrivning': 'Årets avskrivning',
  'clo.assetSchema.saldo.rows.inntektNegSaldo': 'Årets inntektsføring av negativ saldo',
  'clo.assetSchema.saldo.rows.utgaende': 'Utgående verdi',
  'clo.assetSchema.saldo.rows.ufrivillig': 'Er realisasjonen ufrivillig og gevinsten betinget skattefri',
  'clo.assetSchema.saldo.rows.erstatning': 'Erstatningsbeløp ved ufrivillig realisasjon',
  'clo.assetSchema.saldo.rows.reinvestert': 'Reinvestert betinget skattefri salgsgevinst',
  'clo.assetSchema.saldo.rows.objektidNed': 'Objektidentifikator nedskrivningen med betinget skattefri salgsgevinst gjelder',
  'clo.assetSchema.saldo.rows.tilskuddDistrikt': 'Tilskudd til investering i distriktene',
  'clo.assetSchema.saldo.rows.tilbakeforing': 'Tilbakeføring av tilskudd til investering i distriktene',
  'clo.assetSchema.linear.title': 'Lineært avskrevet anleggsmiddel',
  'clo.assetSchema.linear.lead': 'Brukes for eiendeler som avskrives med like store beløp over levetiden, for eksempel enkelte rettigheter eller leietakerinvesteringer.',
  'clo.assetSchema.linear.rows.objectId': 'Objektidentifikator',
  'clo.assetSchema.linear.rows.beskrivelse': 'Objektbeskrivelse',
  'clo.assetSchema.linear.rows.inngaende': 'Inngående verdi',
  'clo.assetSchema.linear.rows.pakostning': 'Påkostning',
  'clo.assetSchema.linear.rows.anskaffelseskost': 'Anskaffelseskost',
  'clo.assetSchema.linear.rows.ervervsdato': 'Ervervsdato',
  'clo.assetSchema.linear.rows.levetid': 'Levetid',
  'clo.assetSchema.linear.rows.vederlag': 'Vederlag ved realisasjon og uttak',
  'clo.assetSchema.linear.rows.grunnlag': 'Grunnlag for avskrivning og inntektsføring',
  'clo.assetSchema.linear.rows.gevinstOverf': 'Gevinst overført til gevinst- og tapskonto',
  'clo.assetSchema.linear.rows.tapOverf': 'Tap overført til gevinst- og tapskonto',
  'clo.assetSchema.linear.rows.avskrivning': 'Årets avskrivning',
  'clo.assetSchema.linear.rows.utgaende': 'Utgående verdi',
  'clo.assetSchema.none.title': 'Ikke avskrivbart anleggsmiddel',
  'clo.assetSchema.none.lead': 'Brukes for eiendeler uten skattemessig avskrivning, for eksempel tomt, bolig, kunstverk eller finansielle anleggsmidler.',
  'clo.assetSchema.none.rows.objectId': 'Objektidentifikator',
  'clo.assetSchema.none.rows.beskrivelse': 'Objektbeskrivelse',
  'clo.assetSchema.none.rows.inngaende': 'Inngående verdi',
  'clo.assetSchema.none.rows.nyanskaffelse': 'Nyanskaffelse',
  'clo.assetSchema.none.rows.pakostning': 'Påkostning',
  'clo.assetSchema.none.rows.ervervsdato': 'Ervervsdato',
  'clo.assetSchema.none.rows.vederlag': 'Vederlag ved realisasjon og uttak',
  'clo.assetSchema.none.rows.grunnlag': 'Grunnlag for avskrivning og inntektsføring',
  'clo.assetSchema.none.rows.gevinstOverf': 'Gevinst overført til gevinst- og tapskonto',
  'clo.assetSchema.none.rows.tapOverf': 'Tap overført til gevinst- og tapskonto',
  'clo.assetSchema.none.rows.utgaende': 'Utgående verdi',
  'clo.assetSchema.gtk.title': 'Gevinst- og tapskonto',
  'clo.assetSchema.gtk.lead': 'Brukes når gevinst eller tap på større eiendeler skal inntekts- eller fradragsføres gradvis over flere år.',
  'clo.assetSchema.gtk.rows.objectId': 'Gevinst- og tapskontoidentifikator',
  'clo.assetSchema.gtk.rows.kommunenummer': 'Kommunenummer',
  'clo.assetSchema.gtk.rows.inngaende': 'Inngående verdi',
  'clo.assetSchema.gtk.rows.sumGevinst': 'Sum gevinst ved realisasjon og uttak',
  'clo.assetSchema.gtk.rows.sumTap': 'Sum tap ved realisasjon og uttak',
  'clo.assetSchema.gtk.rows.gevinstBuskap': 'Gevinst ved realisasjon av hel buskap på gårdsbruk ved opphør av driftsgren',
  'clo.assetSchema.gtk.rows.inngaendeErvervet': 'Inngående verdi fra ervervet gevinst- og tapskonto',
  'clo.assetSchema.gtk.rows.realisert': 'Verdi av realisert gevinst- og tapskonto',
  'clo.assetSchema.gtk.rows.grunnlag': 'Grunnlag for årets inntekts- og fradragsføring',
  'clo.assetSchema.gtk.rows.sats': 'Sats for inntektsføring og inntektsfradrag',
  'clo.assetSchema.gtk.rows.inntekt': 'Inntekt fra gevinst- og tapskonto',
  'clo.assetSchema.gtk.rows.inntektsfradrag': 'Inntektsfradrag fra gevinst- og tapskonto',
  'clo.assetSchema.gtk.rows.utgaende': 'Utgående verdi',
  'clo.assetSchema.gtk.rows.stammer2015': 'Gevinst- og tapskonto stammer fra tomt tom. 2015',
  'clo.assetSchema.gtk.rows.stammer2016': 'Gevinst- og tapskonto stammer fra gårdsbruk/skogbruk fom. 2016',
  'clo.otherInv.aksje_reg.title': 'Aksje i aksjonærregisteret',
  'clo.otherInv.aksje_reg.tableTitle': 'Aksje i aksjonærregisteret',
  'clo.otherInv.aksje_reg.rows.selskapnavn': 'Selskapets navn',
  'clo.otherInv.aksje_reg.rows.orgnr': 'Selskapets organisasjonsnummer',
  'clo.otherInv.aksje_reg.rows.landkode': 'Landkode',
  'clo.otherInv.aksje_reg.rows.fritak': 'Er omfattet av fritaksmetoden',
  'clo.otherInv.aksje_reg.rows.aksjeklasse': 'Aksjeklasse',
  'clo.otherInv.aksje_reg.rows.isin': 'Isinnummer',
  'clo.otherInv.aksje_reg.rows.antall': 'Antall aksjer',
  'clo.otherInv.aksje_reg.rows.utbytte': 'Utbytte',
  'clo.otherInv.aksje_reg.rows.gevinst': 'Gevinst ved realisasjon av aksje',
  'clo.otherInv.aksje_reg.rows.tap': 'Tap ved realisasjon av aksje',
  'clo.otherInv.aksje_reg.rows.formue': 'Formuesverdi',
  'clo.otherInv.aksje_ikke.title': 'Aksje ikke i aksjonærregisteret',
  'clo.otherInv.aksje_ikke.tableTitle': 'Aksje ikke i aksjonærregisteret',
  'clo.otherInv.aksje_ikke.rows.finansid': 'Finansproduktidentifikator',
  'clo.otherInv.aksje_ikke.rows.finansidtype': 'Finansproduktidentifikatortype',
  'clo.otherInv.aksje_ikke.rows.kontofnavn': 'Kontoførers navn',
  'clo.otherInv.aksje_ikke.rows.kontonr': 'Kontonummer',
  'clo.otherInv.aksje_ikke.rows.selskapnavn': 'Selskapets navn',
  'clo.otherInv.aksje_ikke.rows.orgnr': 'Selskapets organisasjonsnummer',
  'clo.otherInv.aksje_ikke.rows.landkode': 'Landkode',
  'clo.otherInv.aksje_ikke.rows.fritak': 'Er omfattet av fritaksmetoden',
  'clo.otherInv.aksje_ikke.rows.antall': 'Antall aksjer',
  'clo.otherInv.aksje_ikke.rows.utbytte': 'Utbytte',
  'clo.otherInv.aksje_ikke.rows.gevinst': 'Gevinst ved realisasjon av aksje',
  'clo.otherInv.aksje_ikke.rows.tap': 'Tap ved realisasjon av aksje',
  'clo.otherInv.aksje_ikke.rows.formue': 'Formuesverdi',
  'clo.otherInv.verdipapirfond.title': 'Verdipapirfond',
  'clo.otherInv.verdipapirfond.tableTitle': 'Verdipapirfond',
  'clo.otherInv.verdipapirfond.rows.fondnavn': 'Fondets navn',
  'clo.otherInv.verdipapirfond.rows.fondorgnr': 'Fondets organisasjonsnummer',
  'clo.otherInv.verdipapirfond.rows.landkode': 'Landkode',
  'clo.otherInv.verdipapirfond.rows.fritak': 'Er omfattet av fritaksmetoden',
  'clo.otherInv.verdipapirfond.rows.isin': 'Isinnummer',
  'clo.otherInv.verdipapirfond.rows.antallandeler': 'Antall andeler',
  'clo.otherInv.verdipapirfond.rows.utbytte': 'Utbytte',
  'clo.otherInv.verdipapirfond.rows.renteinntekt': 'Renteinntekt',
  'clo.otherInv.verdipapirfond.rows.gevinstaksjedel': 'Gevinst ved realisasjon av andel i aksjedel',
  'clo.otherInv.verdipapirfond.rows.tapaksjedel': 'Tap ved realisasjon av andel i aksjedel',
  'clo.otherInv.verdipapirfond.rows.gevinstrentedel': 'Gevinst ved realisasjon av andel i rentedel',
  'clo.otherInv.verdipapirfond.rows.taprentedel': 'Tap ved realisasjon av andel i rentedel',
  'clo.otherInv.verdipapirfond.rows.formue': 'Formuesverdi',
  'clo.otherInv.obligasjon.title': 'Obligasjon og sertifikat',
  'clo.otherInv.obligasjon.tableTitle': 'Obligasjon og sertifikat',
  'clo.otherInv.obligasjon.rows.navn': 'Rentepapirets navn',
  'clo.otherInv.obligasjon.rows.kontofnavn': 'Kontoførers navn',
  'clo.otherInv.obligasjon.rows.kontonr': 'Kontonummer',
  'clo.otherInv.obligasjon.rows.finansid': 'Finansproduktidentifikator',
  'clo.otherInv.obligasjon.rows.finansidtype': 'Finansproduktidentifikatortype',
  'clo.otherInv.obligasjon.rows.landkode': 'Landkode',
  'clo.otherInv.obligasjon.rows.antall': 'Antall obligasjon og sertifikat',
  'clo.otherInv.obligasjon.rows.renteinntekt': 'Renteinntekt av obligasjon og sertifikat',
  'clo.otherInv.obligasjon.rows.gevinst': 'Gevinst ved realisasjon av obligasjon og sertifikat',
  'clo.otherInv.obligasjon.rows.tap': 'Tap ved realisasjon av obligasjon og sertifikat',
  'clo.otherInv.obligasjon.rows.formue': 'Formuesverdi',
  'clo.otherInv.virtuell.title': 'Virtuell valuta',
  'clo.otherInv.virtuell.tableTitle': 'Virtuell valuta',
  'clo.otherInv.virtuell.rows.navn': 'Virtuell valutanavn',
  'clo.otherInv.virtuell.rows.kontonr': 'Kontonummer',
  'clo.otherInv.virtuell.rows.landkode': 'Landkode',
  'clo.otherInv.virtuell.rows.antall': 'Antall',
  'clo.otherInv.virtuell.rows.flere': 'Gjelder flere virtuelle valutaer',
  'clo.otherInv.virtuell.rows.kapitalinntekt': 'Kapitalinntekt fra virtuell valuta',
  'clo.otherInv.virtuell.rows.gevinst': 'Gevinst ved realisasjon av virtuell valuta',
  'clo.otherInv.virtuell.rows.tap': 'Tap ved realisasjon av virtuell valuta',
  'clo.otherInv.virtuell.rows.formue': 'Formuesverdi',
  'clo.otherInv.virtuell.sections.lommebok': 'Lommebok',
  'clo.otherInv.virtuell.rows.lommebokadresse': 'Lommebokadresse',
  'clo.otherInv.virtuell.sections.bors': 'Børs',
  'clo.otherInv.virtuell.rows.borsnavn': 'Børsnavn',
  'clo.otherInv.fondskonto.title': 'Fondskonto',
  'clo.otherInv.fondskonto.tableTitle': 'Fondskonto',
  'clo.otherInv.fondskonto.rows.forsorgnr': 'Forsikringsselskapets organisasjonsnummer',
  'clo.otherInv.fondskonto.rows.forsnavn': 'Forsikringsselskapets navn',
  'clo.otherInv.fondskonto.rows.kontonr': 'Kontonummer',
  'clo.otherInv.fondskonto.rows.fritak': 'Er omfattet av fritaksmetoden',
  'clo.otherInv.fondskonto.rows.gevaksje': 'Skattepliktig gevinst ved realisasjon av og uttak fra aksjedel',
  'clo.otherInv.fondskonto.rows.tapaksje': 'Skattepliktig tap ved realisasjon av og uttak fra aksjedel',
  'clo.otherInv.fondskonto.rows.gevrente': 'Skattepliktig gevinst ved realisasjon av og uttak fra rentedel',
  'clo.otherInv.fondskonto.rows.taprente': 'Skattepliktig tap ved realisasjon av og uttak fra rentedel',
  'clo.otherInv.fondskonto.rows.skattefritt': 'Skattefritt uttak',
  'clo.otherInv.fondskonto.rows.formue': 'Formuesverdi',
  'clo.otherInv.other.title': 'Annet finansprodukt',
  'clo.otherInv.other.tableTitle': 'Annet finansprodukt',
  'clo.otherInv.other.rows.navn': 'Finansproduktnavn',
  'clo.otherInv.other.rows.kontonr': 'Kontonummer',
  'clo.otherInv.other.rows.type': 'Finansprodukttype',
  'clo.otherInv.other.rows.finansid': 'Finansproduktidentifikator',
  'clo.otherInv.other.rows.finansidtype': 'Finansproduktidentifikatortype',
  'clo.otherInv.other.rows.landkode': 'Landkode',
  'clo.otherInv.other.rows.fritak': 'Er omfattet av fritaksmetoden',
  'clo.otherInv.other.rows.antall': 'Antall andre finansprodukter',
  'clo.otherInv.other.rows.renteinntekt': 'Renteinntekt',
  'clo.otherInv.other.rows.kapitalinntekt': 'Kapitalinntekt fra annet finansprodukt',
  'clo.otherInv.other.rows.gevinst': 'Gevinst ved realisasjon av annet finansprodukt',
  'clo.otherInv.other.rows.tap': 'Tap ved realisasjon av annet finansprodukt',
  'clo.otherInv.other.rows.formue': 'Formuesverdi',
  'clo.otherInv.daans.title': 'Selskap med deltakerfastsetting (DA/ANS)',
  'clo.otherInv.daans.tableTitle': 'Deltakers andel av formue og inntekt',
  'clo.otherInv.daans.rows.selskapnavn': 'Selskapets navn',
  'clo.otherInv.daans.rows.orgnr': 'Selskapets organisasjonsnummer',
  'clo.otherInv.daans.rows.verdifor': 'Verdi før verdsettingsrabatt for nettoformue',
  'clo.otherInv.daans.rows.gjeld': 'Gjeld',
  'clo.otherInv.daans.rows.gevinst': 'Gevinst ved realisasjon av andel',
  'clo.otherInv.daans.rows.tap': 'Tap ved realisasjon av andel',
  'clo.otherInv.daans.rows.underskudd': 'Underskudd',
  'clo.otherInv.daans.rows.alminnelig': 'Alminnelig inntekt',
  'clo.otherInv.daans.rows.utbetaling': 'Utbetaling mv til deltaker',
  'clo.otherInv.daans.rows.landkode': 'Landkode',
  'clo.otherInv.daans.rows.kommunenr': 'Kommunenummer',
  'clo.otherInv.daans.rows.arsak': 'Årsak til valg av annen verdi før verdsettelsesrabatt for nettoformue for deltaker i NOKUS',
  'clo.otherInv.daans.rows.nokus': 'Selskap med deltakerfastsetting er NOKUS',
  'clo.otherInv.daans.rows.usdf': 'Selskap med deltakerfastsetting er USDF',
  'clo.otherInv.daans.sections.utland_inntekt': 'Inntekt underlagt beskatning i utlandet',
  'clo.otherInv.daans.rows.ui_belopnok': 'Beløp i NOK',
  'clo.otherInv.daans.rows.ui_belopvaluta': 'Beløp i valuta',
  'clo.otherInv.daans.rows.ui_valutakode': 'Valutakode',
  'clo.otherInv.daans.rows.ui_valutakurs': 'Valutakurs',
  'clo.otherInv.daans.sections.utland_skatt': 'Inntektsskatt betalt i utlandet',
  'clo.otherInv.daans.rows.us_landkode': 'Landkode',
  'clo.otherInv.daans.rows.us_sats': 'Anvendt skattesats',
  'clo.otherInv.daans.rows.us_belopnok': 'Beløp i NOK',
  'clo.otherInv.daans.rows.us_belopvaluta': 'Beløp i valuta',
  'clo.otherInv.daans.rows.us_valutakode': 'Valutakode',
  'clo.otherInv.daans.rows.us_valutakurs': 'Valutakurs',
  'clo.otherInv.daans.sections.kraftverk': 'Deltakers andel i kraftverk',
  'clo.otherInv.daans.rows.kv_pos': 'Andel av positiv grunnrenteinntekt før samordning',
  'clo.otherInv.daans.rows.kv_neg': 'Andel av negativ grunnrenteinntekt før samordning',
  'clo.otherInv.daans.sections.havbruk': 'Deltakers andel i havbruksvirksomhet',
  'clo.otherInv.daans.rows.hb_pos': 'Positiv grunnrenteinntekt før samordning',
  'clo.otherInv.daans.rows.hb_neg': 'Negativ grunnrenteinntekt før samordning',
  'clo.otherInv.daans.rows.hb_avgift': 'Produksjonsavgift',
  'clo.otherInv.daans.sections.kildeskatt': 'Deltakers andel av skattetrekk for kildeskatt på rente royalty mv',
  'clo.otherInv.daans.rows.ks_type': 'Inntektstype',
  'clo.otherInv.daans.rows.ks_belop': 'Skattetrekksbeløp',
  'clo.otherInv.daans.sections.fou': 'Deltakers andel av skattefradrag for kostnader til forskning og utvikling',
  'clo.otherInv.daans.rows.fou_fradrag': 'Samlet skattefradrag',
  'clo.otherInv.daans.rows.fou_tillegg': 'Samlet tillegg i beregnet skatt',
  'clo.otherInv.daans.sections.rederi': 'Deltakers andel av inntekt omfattet av rederiskatteordningen',
  'clo.otherInv.daans.rows.rd_inntekt': 'Andel av samlet inntekt',
  'clo.otherInv.daans.rows.rd_underskudd': 'Andel av samlet underskudd',
  'clo.otherInv.daans.rows.rd_tonnasje': 'Andel av tonnasjeskatt',
  'clo.otherInv.daans.rows.rd_metode': 'Metode for bokføring i deltakers regnskap',
  'clo.otherInv.daans.sections.vindkraft': 'Deltakers andel i landbasert vindkraft',
  'clo.otherInv.daans.rows.vk_lopenr': 'Løpenummer',
  'clo.otherInv.daans.rows.vk_navn': 'Kraftverkets navn',
  'clo.otherInv.daans.rows.vk_pos': 'Andel av positiv grunnrenteinntekt før samordning',
  'clo.otherInv.daans.rows.vk_neg': 'Andel av negativ grunnrenteinntekt før samordning',
  'clo.checked': 'Kontrollert',
  'clo.notChecked': 'Ikke kontrollert',
  'clo.addAction': 'Legg til',
  'clo.taxIb.naturalBenefitsCredited': 'Samlet beløp som er kreditert konto for naturalytelser',
  'clo.taxIb.pensionContributionYear': 'Årets innbetaling av arbeidsgiveravgiftspliktig tilskudd og premie til pensjonsordning',
  'clo.taxIbSpecType.accommodation': 'Overnattings- og serveringssted',
  'clo.taxIbSpecType.taxi': 'Drosje- og godstransport',
  'clo.taxIbSpecType.payroll': 'Lønns- og pensjonskostnad',
  'clo.taxIbEquityLabel.andrePositiveEndringerIEgenkapital': 'Andre positive endringer i egenkapital',
  'clo.taxIbEquityLabel.gjeldKonvertertTilEgenkapital': 'Gjeld konvertert til egenkapital',
  'clo.taxIbEquityLabel.gjeldsettergivelse': 'Gjeldsettergivelse',
  'clo.taxIbEquityLabel.kontantinnskudd': 'Kontantinnskudd',
  'clo.taxIbEquityLabel.mottattKonsernbidrag': 'Mottatt konsernbidrag',
  'clo.taxIbEquityLabel.differanseMellomAvsattForventetUtbytteOgUtdeltUtbytteNarDenneErPositiv': 'Differanse mellom avsatt/forventet utbytte og utdelt utbytte når denne er positiv',
  'clo.taxIbEquityLabel.salgAvEgneAksjer': 'Salg av egne aksjer',
  'clo.taxIbEquityLabel.tinginnskudd': 'Tinginnskudd',
  'clo.taxIbEquityLabel.aretsUnderskudd': 'Årets underskudd',
  'clo.taxIbEquityLabel.andreNegativeEndringerIEgenkapital': 'Andre negative endringer i egenkapital',
  'clo.taxIbEquityLabel.avgittKonsernbidrag': 'Avgitt konsernbidrag',
  'clo.taxIbEquityLabel.avsattEllerForventetUtbytte': 'Avsatt eller forventet utbytte',
  'clo.taxIbEquityLabel.ekstraordinRtUtbytte': 'Ekstraordinært utbytte',
  'clo.taxIbEquityLabel.kjPAvEgneAksjer': 'Kjøp av egne aksjer',
  'clo.taxIbEquityLabel.nedsettelseAvAksjekapitalOgUtdelingAvOverkursAndreEiendeler': 'Nedsettelse av aksjekapital og utdeling av overkurs – andre eiendeler',
  'clo.taxIbEquityLabel.nedsettelseAvAksjekapitalOgUtdelingAvOverkursKontanter': 'Nedsettelse av aksjekapital og utdeling av overkurs – kontanter',
  'clo.taxIbEquityLabel.differanseMellomAvsattForventetUtbytteOgUtdeltUtbytteNarDenneErNegativ': 'Differanse mellom avsatt/forventet utbytte og utdelt utbytte når denne er negativ',
  'clo.taxIbEquityLabel.tilleggsutbytte': 'Tilleggsutbytte',
  'clo.taxIbInventoryRow.ravareOgInnkjPtHalvfabrikata': 'Råvare og innkjøpt halvfabrikata',
  'clo.taxIbInventoryRow.vareUnderTilvirkning': 'Vare under tilvirkning',
  'clo.taxIbInventoryRow.ferdigTilvirketVare': 'Ferdig tilvirket vare',
  'clo.taxIbInventoryRow.innkjPtVareForVideresalg': 'Innkjøpt vare for videresalg',
  'clo.taxIbInventoryRow.buskap': 'Buskap',
  'clo.taxIbInventoryRow.selvprodusertVareBenyttetIEgenProduksjon': 'Selvprodusert vare benyttet i egen produksjon',
  'clo.taxIbInventoryRow.reinPelsdyrOgPelsdyrskinnPaLager': 'Rein, pelsdyr og pelsdyrskinn på lager',
  'clo.additionsGroup': 'Tillegg',
  'clo.deductionsGroup': 'Fradrag',
  'clo.taxIbSpecCfg.accommodation.title': 'Overnattings- og serveringssted',
  'clo.taxIbSpecCfg.accommodation.rows.orgnr': 'Organisasjonsnummer',
  'clo.taxIbSpecCfg.accommodation.rows.fnr': 'Fødselsnummer',
  'clo.taxIbSpecCfg.accommodation.rows.avgpl': 'Avgiftspliktig inntekt fra inngangspenger',
  'clo.taxIbSpecCfg.accommodation.rows.avgfri': 'Avgiftsfri inntekt fra inngangspenger',
  'clo.taxIbSpecCfg.accommodation.rows.garderobe': 'Garderobeinntekt',
  'clo.taxIbSpecCfg.accommodation.rows.revisor': 'Skal bekreftes av revisor',
  'clo.taxIbSpecCfg.accommodation.rows.pu1': 'Uttak av varer til privat bruk er verdsatt til omsetningsverdi',
  'clo.taxIbSpecCfg.accommodation.rows.pu2': 'Private uttak er ført på privatkonto',
  'clo.taxIbSpecCfg.accommodation.rows.pu3': 'Samlet uttak av varer til privat bruk ført som salgsinntekt',
  'clo.taxIbSpecCfg.accommodation.rows.re1': 'Uttak av kostvarer mv. til representasjon',
  'clo.taxIbSpecCfg.accommodation.rows.re2': 'Uttaksverdi er verdsatt til omsetningsverdi',
  'clo.taxIbSpecCfg.accommodation.rows.re3': 'Påslag ved uttak av kostvarer mv. til representasjon',
  'clo.taxIbSpecCfg.accommodation.rows.re4': 'Samlet uttak av kostvarer mv. til representasjon',
  'clo.taxIbSpecCfg.accommodation.layout.privateWithdrawals': 'Privat uttak av varer',
  'clo.taxIbSpecCfg.accommodation.layout.entertainment': 'Representasjon',
  'clo.taxIbSpecCfg.accommodation.tables.cashSystems.title': 'Kassasystem',
  'clo.taxIbSpecCfg.accommodation.tables.cashSystems.note': 'Alle påkrevde felter må fylles ut. Klikk deg inn på hvert kassasystem og fyll ut opplysningene.',
  'clo.taxIbSpecCfg.accommodation.tables.cashSystems.anskaffelsesarAvKassasystem': 'Anskaffelsesår av kassasystem',
  'clo.taxIbSpecCfg.accommodation.tables.cashSystems.kassasystemtype': 'Kassasystemtype',
  'clo.taxIbSpecCfg.accommodation.tables.inventoryByKind.title': 'Varelager per vareart',
  'clo.taxIbSpecCfg.accommodation.tables.inventoryByKind.note': 'Alle påkrevde felter må fylles ut. Klikk deg inn på hver vareart og fyll ut opplysningene.',
  'clo.taxIbSpecCfg.accommodation.tables.inventoryByKind.vareart': 'Vareart',
  'clo.taxIbSpecCfg.accommodation.tables.inventoryByKind.varelagerPer1Januar': 'Varelager per 1. januar',
  'clo.taxIbSpecCfg.accommodation.tables.inventoryByKind.varelagerPer31Desember': 'Varelager per 31. desember',
  'clo.taxIbSpecCfg.accommodation.tables.inventoryByKind.solgteVarersInntakskost': 'Solgte varers inntakskost',
  'clo.taxIbSpecCfg.accommodation.tables.inventoryByKind.salgsinntektOgUttak': 'Salgsinntekt og uttak',
  'clo.taxIbSpecCfg.taxi.title': 'Løyve for drosje og godstransport',
  'clo.taxIbSpecCfg.taxi.rows.loyve': 'Løyvenummer',
  'clo.taxIbSpecCfg.taxi.rows.bransje': 'Bransje',
  'clo.taxIbSpecCfg.taxi.tables.vehicles.title': 'Kjøretøy',
  'clo.taxIbSpecCfg.taxi.tables.vehicles.note': 'Alle påkrevde felter må fylles ut. Klikk deg inn på kjøretøyet og fyll ut opplysningene.',
  'clo.taxIbSpecCfg.taxi.tables.vehicles.kjennemerke': 'Kjennemerke',
  'clo.taxIbSpecCfg.taxi.tables.vehicles.drosjevirksomhetErKnyttetTilEnSentral': 'Drosjevirksomhet er knyttet til en sentral',
  'clo.taxIbSpecCfg.taxi.tables.vehicles.taksametertype': 'Taksametertype',
  'clo.taxIbSpecCfg.taxi.tables.vehicles.antallLiterDrivstoff': 'Antall liter drivstoff',
  'clo.taxIbSpecCfg.taxi.tables.vehicles.kjReinntektKontant': 'Kjøreinntekt kontant',
  'clo.taxIbSpecCfg.taxi.tables.vehicles.inntektFraPersontransportMedKortEllerEtterskuddsvis12ProsentMva': 'Inntekt fra persontransport med kort eller etterskuddsvis 12 prosent mva',
  'clo.taxIbSpecCfg.taxi.tables.vehicles.inntektFraVaretransportMedKredittkortEllerEtterskuddsvis25ProsentMva': 'Inntekt fra varetransport med kredittkort eller etterskuddsvis 25 prosent mva',
  'clo.taxIbSpecCfg.taxi.tables.vehicles.kjReinntektFakturertOffentligeEtater': 'Kjøreinntekt fakturert offentlige etater',
  'clo.taxIbSpecCfg.taxi.tables.vehicles.tipsMedKredittkortEllerEtterskuddsvis': 'Tips med kredittkort eller etterskuddsvis',
  'clo.taxIbSpecCfg.taxi.tables.vehicles.tipsKontant': 'Tips kontant',
  'clo.taxIbSpecCfg.taxi.tables.vehicles.lengdeMedSkolebarnkjRing': 'Lengde med skolebarnkjøring',
  'clo.taxIbSpecCfg.taxi.tables.vehicles.lengdeMedBesattBilNarTaksameterErIBruk': 'Lengde med besatt bil når taksameter er i bruk',
  'clo.taxIbSpecCfg.taxi.tables.vehicles.belPFraBomturerRegistrertPaTaksameter': 'Beløp fra bomturer registrert på taksameter',
  'clo.taxIbSpecCfg.payroll.title': 'Lønns- og pensjonskostnad',
  'clo.taxIbSpecCfg.payroll.rows.kontonr': 'Kontonummer',
  'clo.taxIbSpecCfg.payroll.rows.kontonavn': 'Kontonavn',
  'clo.taxIbSpecCfg.payroll.rows.lonnytelse': 'Lønnsopplysningspliktig ytelse',
  'clo.taxIbSpecCfg.payroll.rows.tillegg': 'Tillegg for kostnadsført lønn mv. tidligere år',
  'clo.taxIbSpecCfg.payroll.rows.fradrag': 'Fradrag for påløpt, ikke forfalt lønn mv. som ikke er rapportert',
  'clo.taxIbSpecCfg.payroll.rows.agift': 'Arbeidsgiveravgiftspliktig ytelse',
  'clo.taxStep.summary.label': 'Oppsummering',
  'clo.taxStep.summary.help': 'Øverste oppsummering: kontaktinfo, regnskapsperiode, beregnet skatt og formue/gjeld. Kontroller at grunnopplysningene stemmer før du går videre.',
  'clo.taxStep.taxBase.label': 'Skattegrunnlag',
  'clo.taxStep.taxBase.help': 'Her beregnes skattegrunnlaget: regnskapsmessig resultat justert for permanente og midlertidige forskjeller (f.eks. ulike avskrivninger i regnskap og skatt), samt fremført underskudd.',
  'clo.taxStep.wealth.label': 'Formue og gjeld',
  'clo.taxStep.wealth.help': 'Formue og gjeld ved årsskiftet danner grunnlag for formuesfastsetting hos eierne. Betalinger etter nyttår kan fortsatt stå som gjeld eller fordring per 31.12. Plumme beregner ikke all formue automatisk, så kontroller detaljene hvis selskapet har eiendeler, aksjer eller investeringer, eiendom, annen formue eller gjeld.',
  'clo.taxStep.assets.label': 'Eiendeler',
  'clo.taxStep.assets.help': 'Her spesifiseres anleggsmidler som inngår i skattemeldingen: saldoavskrevne, lineært avskrevne, ikke-avskrivbare og gevinst- og tapskonto. Registrerte driftsmidler hentes automatisk fra eiendelsregisteret. Manuelle tillegg lagres bare i skattemeldingsutkastet for valgt år.',
  'clo.taxStep.other.label': 'Andre opplysninger',
  'clo.taxStep.other.help': 'Her legger du inn opplysninger som skal leveres som del av skattemeldingen, men som ikke endrer skattegrunnlaget direkte i dette steget. Plumme viser forslag fra regnskapet der det finnes spor, og lar deg fylle ut manglende eierskap, ytelser og investeringer manuelt.',
  'clo.taxStep.incomeBalance.label': 'Resultatregnskap og balanse',
  'clo.taxStep.incomeBalance.help': 'Denne fanen henter resultatregnskap og balanse fra regnskapet i Plumme. Manuelle tillegg lagres bare i skattemeldingsutkastet. Hvis regnskapstallene er feil, bør regnskapet korrigeres før du oppretter et nytt skattemeldingsutkast.',
  'clo.taxStep.all.label': 'Alle opplysninger',
  'clo.taxStep.all.help': 'Her får du en samlet kontrollside for skattemeldingen. Hvert tema viser nøkkelopplysninger fra regnskapet i Plumme og skattemeldingsutkastet, med detaljer i en egen dialog. Kontroller eventuelle avvik før innsending.',
  'clo.taxRail.0': 'Se gjennom og fyll ut',
  'clo.taxRail.1': 'Kontroller næringsopplysninger',
  'clo.taxRail.2': 'Send til Skatteetaten',
  'clo.taxRail.3': 'Skatteetaten behandler',
  'clo.taxRail.4': 'Ferdig',
  'clo.myBusinessFallback': 'Mitt foretak',
  'clo.contactPersonFallback': 'Kontaktperson',
  'clo.ruleType.smaForetak': 'Regnskapslovens regler for små foretak',
  'clo.ruleType.ovrigeForetak': 'Regnskapslovens regler for øvrige foretak',
  'clo.ruleType.forenkletIfrs': 'Forenklet IFRS',
  'clo.ruleType.fullIfrs': 'Full IFRS',
  'clo.ruleType.noAccountingDuty': 'Bokføringsplikt uten årsregnskap',
  'clo.taxAssetAutoNote': 'Automatiske saldogrupper hentes fra Plummes eiendelsregister. Manuelle rader her lagres i skattemeldingsutkastet for året og bør kontrolleres mot dokumentasjon før innsending.',
  'clo.otherInvestmentAutoNote': 'Opplysningene lagres i skattemeldingsutkastet for året. Tall fra saldobalansen vises som forslag, mens manuelle investeringsposter kan redigeres her.',
  'clo.noRelevantAccountBalance': 'Ingen saldo på relevante kontoer.',
  'clo.taxIbSpecAutoNote': 'Spesifikasjonen lagres bare i skattemeldingsutkastet. Fyll inn feltene som gjelder selskapet.',
  'clo.inventoryPanelIntro': 'Denne viser hva varelageret består av, mer detaljert enn balanseposten. Opplysningene brukes også til midlertidige forskjeller i skattemeldingen.',
  'clo.receivablesPanelIntro': 'Denne viser hvordan fordringene er sammensatt, og eventuell skattemessig sjablongnedskrivning på tap på fordringer.',
  'clo.positivePrincipleChange': 'Positiv prinsippendring',
  'clo.negativePrincipleChange': 'Negativ prinsippendring',
  'clo.equityPanelIntro': 'Her vises egenkapitalen ved starten av året, hvilke endringer som har skjedd, og egenkapitalen ved slutten av året.',
  'clo.taxIbReceivables.kundefordringOgIkkeFakturertDriftsinntekt': 'Kundefordring og ikke fakturert driftsinntekt',
  'clo.taxIbReceivables.konstatertTapPaKundefordring': 'Konstatert tap på kundefordring',
  'clo.taxIbReceivables.konstatertTapPaKundefordringIFjor': 'Konstatert tap på kundefordring i fjor',
  'clo.taxIbReceivables.kredittsalg': 'Kredittsalg',
  'clo.taxIbReceivables.kredittsalgIFjor': 'Kredittsalg i fjor',
  'clo.taxIbReceivables.skattemessigNedskrivningPaKundefordring': 'Skattemessig nedskrivning på kundefordring',
  'clo.taxIbReceivables.skattemessigVerdiPaKundefordring': 'Skattemessig verdi på kundefordring',
  'clo.taxIbReceivables.annenFordring': 'Annen fordring',
  'clo.taxIbReceivables.skattemessigNedskrivningPaKundefordringForNyetablertVirksomhet': 'Skattemessig nedskrivning på kundefordring for nyetablert virksomhet',
  'clo.taxIbReceivables.sumSkattemessigVerdiPaFordring': 'Sum skattemessig verdi på fordring',
  'clo.closeDetails': 'Lukk detaljer',
  'clo.changeItem': 'Endre {{item}}',
  'clo.additionsToBusinessIncome': 'Tillegg i næringsinntekt',
  'clo.deductionsFromBusinessIncome': 'Fradrag fra næringsinntekt',
  'clo.taxIbAccountGroup.balanseverdiForAnleggsmiddel': 'Balanseverdi for anleggsmiddel',
  'clo.taxIbAccountGroup.balanseverdiForOmlPsmiddel': 'Balanseverdi for omløpsmiddel',
  'clo.taxIbAccountGroup.egenkapital': 'Egenkapital',
  'clo.taxIbAccountGroup.gjeld': 'Gjeld',
  'clo.taxIbAccountGroup.driftsinntekt': 'Driftsinntekt',
  'clo.taxIbAccountGroup.driftskostnad': 'Driftskostnad',
  'clo.taxIbAccountGroup.finanspost': 'Finanspost',
});
